import {
    QUERY_GET_CUSTOMER_SERVICES_BY_CUSTOMER,
    QUERY_POST_CREATE_CUSTOMER_SERVICE,
    QUERY_DELETE_CUSTOMER_SERVICE
} from '../../fetch/constantQueries';
import { baseThunk } from '../../fetch/basicThunk';

export const getCustomerServices = baseThunk('customerServices/getByCustomer', QUERY_GET_CUSTOMER_SERVICES_BY_CUSTOMER, 'GET');
export const createCustomerService = baseThunk('customerServices/create', QUERY_POST_CREATE_CUSTOMER_SERVICE, 'POST');
export const deleteCustomerService = baseThunk('customerServices/delete', QUERY_DELETE_CUSTOMER_SERVICE, 'DELETE');
